import styled from "styled-components";
import { Color, ColorTransform, getColor } from "../../../theme/color";
import { getMediaQuery, getUnitAsPixels, ScreenSize } from "../../../theme/layout";
import { getTypography, Type } from "../../../theme/typography";

export const Container = styled.button<{ $processing?: boolean, $complete?: boolean, $color?: "blue" | "pink" | "grey", $expand?: boolean, $size?: "small" | "large" }>`
  ${getTypography(Type.FORM_BUTTON)}
  background-color: ${({ $complete, $color }) => $complete ? getColor(Color.LIGHT_GREEN) : $color === "pink" ? getColor(Color.PINK) : $color === "grey" ? getColor(Color.LIGHT_GREY) : getColor(Color.DARK_BLUE)};
  height: ${({ $size }) => $size === "small" ? getUnitAsPixels({ multiplier: 6 }) : getUnitAsPixels({ multiplier: 8 })};
  line-height: ${({ $size }) => $size === "small" ? getUnitAsPixels({ multiplier: 6 }) : getUnitAsPixels({ multiplier: 8 })};
  border-radius: ${({ $size }) => $size === "small" ? getUnitAsPixels({ multiplier: 3 }) : getUnitAsPixels({ multiplier: 8 })};
  padding: 0 ${({ $size, $expand }) => $expand ? getUnitAsPixels({ multiplier: 3 }) : $size === "small" ? getUnitAsPixels({ multiplier: 6 }) : getUnitAsPixels({ multiplier: 8 })};
  color: ${({ $complete, $color }) => $complete ? getColor(Color.DARK_BLUE) : $color === "pink" ? getColor(Color.WHITE) : $color === "grey" ? getColor(Color.DARK_BLUE) : getColor(Color.LIGHT_GREY)};
  text-align: center;
  cursor: pointer;
  position: relative;
  ${({ $expand }) => $expand ? `flex: 1;` : ``}
  transition: background-color 0.3s, color 0.3s;

  &:disabled{
    background-color: ${({ $complete }) => $complete ? getColor(Color.LIGHT_GREEN) : getColor(Color.MID_GREY)};
    color: ${({ $complete }) => $complete ? getColor(Color.DARK_BLUE) : getColor(Color.DARK_BLUE)};
    cursor: default;

    svg{
      fill: ${({ $complete }) => $complete ? getColor(Color.DARK_BLUE) : getColor(Color.DARK_BLUE)};
    }
  }

  span{
    border-right: 1px solid ${({ $complete, $color }) => $complete ? ColorTransform(getColor(Color.DARK_BLUE)).alpha(0.5).string() : $color === "pink" ? ColorTransform(getColor(Color.WHITE)).alpha(0.5).string() : ColorTransform(getColor(Color.LIGHT_GREY)).alpha(0.5).string()};
    padding-right: ${getUnitAsPixels({ multiplier: 1 })};
    margin-right: ${getUnitAsPixels({ multiplier: 1 })};
    transition: border-right 0.3s;
  }

  svg{
    position: absolute;
    left: ${getUnitAsPixels({ multiplier: 2 })};
    top: 50%;
    transform: translateY(-50%);
    fill: ${({ $complete, $color }) => $complete ? getColor(Color.DARK_BLUE) : $color === "pink" ? getColor(Color.WHITE) : $color === "grey" ? getColor(Color.DARK_BLUE) : getColor(Color.LIGHT_GREY)};
    transition: fill 0.3s;
    width: ${getUnitAsPixels({ multiplier: 2 })};
  }

  ${getMediaQuery(ScreenSize.LARGE)}{
    svg{
      left: ${({ $size }) => $size === "small" ? getUnitAsPixels({ multiplier: 2 }) : getUnitAsPixels({ multiplier: 2 })};
      width: ${({ $size }) => $size === "small" ? getUnitAsPixels({ multiplier: 2 }) : getUnitAsPixels({ multiplier: 3 })};
    }
  }
  
  @media (hover: hover) {
    &:not([disabled]):hover{
      background-color: ${({ $complete, $color }) => $complete ? getColor(Color.LIGHT_GREEN) : $color === "pink" ? getColor(Color.DARK_BLUE) : getColor(Color.PINK)};
      color: ${({ $complete, $color }) => $complete ? getColor(Color.DARK_BLUE) : $color === "pink" ? getColor(Color.LIGHT_GREY) : getColor(Color.WHITE)};
      
      span{
        border-right: 1px solid ${({ $complete, $color }) => $complete ? ColorTransform(getColor(Color.DARK_BLUE)).alpha(0.5).string() : $color === "pink" ? ColorTransform(getColor(Color.LIGHT_GREY)).alpha(0.5).string() : ColorTransform(getColor(Color.WHITE)).alpha(0.5).string()};
      }
      svg{
        fill: ${({ $complete, $color }) => $complete ? getColor(Color.DARK_BLUE) : $color === "pink" ? getColor(Color.WHITE) : getColor(Color.LIGHT_GREY)};
      }

      &:disabled{
        background-color: ${getColor(Color.MID_GREY)};
        color: ${getColor(Color.DARK_BLUE)};
    
        svg{
          fill: ${getColor(Color.DARK_BLUE)};
        }
      }
    }
  }
`